// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as UsersADefault } from '../../../../../ui-v3/src/assets/icons/default/users/users-a.svg?react';
import { ReactComponent as UsersASolid } from '../../../../../ui-v3/src/assets/icons/solid/users/USERS-A.svg?react';
import { createIcons } from '../../Icon';
const UsersAIcon = /* @__PURE__ */ createIcons('UsersA', {
    default: UsersADefault,
    solid: UsersASolid
});
UsersAIcon.supportedTypes = [
    'default',
    'solid'
];
UsersAIcon.category = 'users';
export default UsersAIcon;
